import { Ban, AlertTriangle, CheckCircle2 } from "lucide-react";
import type { PlatformItem } from "../types/navigator";

export type SensitivityKey = "private" | "public" | "pending";

export interface SensitivityInfo {
  key: SensitivityKey;
  label: string;
  icon: typeof Ban;
  cls: string;
  variant: "sensitivity-private" | "sensitivity-public" | "sensitivity-pending";
}

/**
 * Classifies a platform's data-approval state for the card badge, corner
 * icon, and legend quick-filter — single source of truth so all three always
 * agree. There is no separate "approved for company data" column anymore
 * (removed from SharePoint) — this is now derived entirely from the Status
 * value itself: a status mentioning "High" is a high-disclosure-risk
 * approval, one mentioning "Low" is a low-disclosure-risk approval, and
 * anything else (New, Under Review, Forbidden, etc.) is Not Approved, shown
 * with its real status text rather than a generic message.
 */
export function sensitivityInfo(item: PlatformItem): SensitivityInfo {
  const status = (item.status || "").toLowerCase();
  if (/high/.test(status)) {
    return {
      key: "private",
      label: "Approved for High Disclosure Risk Data",
      icon: CheckCircle2,
      cls: "card-sensitivity-private",
      variant: "sensitivity-private",
    };
  }
  if (/low/.test(status)) {
    return {
      key: "public",
      label: "Approved for Low Disclosure Risk Data",
      icon: AlertTriangle,
      cls: "card-sensitivity-public",
      variant: "sensitivity-public",
    };
  }
  return {
    key: "pending",
    label: item.status || "Not Approved",
    icon: Ban,
    cls: "card-sensitivity-pending",
    variant: "sensitivity-pending",
  };
}
